module.exports = __webpack_public_path__ + "img/flat_concrete.c6e650ee.jpg";